export const formatFilter = {
    from: "start_date",
    to: 'end_date',
    status: "status_ids",
    role: "role_ids",
    stores: "store_ids",
    userType: "user_type_ids",
    area: "areas_ids",
    department: "departments_ids"
  }